<div class="flex items-center justify-center">
  <ng-container *ngIf="!formAberto">
    <button
      *isAllowed="[ERoleAdminString.Admin, 'company.create']"
      type="button"
      class="w-80 btn btn--secondary mr-5"
      (click)="formAberto = true"
    >
      Cadastrar Novo
    </button>
  </ng-container>

  <button
    *ngIf="formAberto"
    type="button"
    class="btn btn--secondary px-5 h-9 leading-4 text-center ml-auto"
    (click)="formAberto = false"
  >
    X
  </button>
</div>

<ng-container *ngIf="formAberto">
  <h1 class="text-lg font-bold leading-3">CADASTRAR NOVA EMPRESA</h1>
  <small class="text-xs text-chathams-blue">Insira os dados abaixo para cadastrar</small>

  <form class="flex flex-col gap-5" [formGroup]="formCompany">
    <div class="flex flex-col gap-3 md:flex-row">
      <div
        class="relative rounded border border-gray-500 w-28 h-24 flex items-center justify-center cursor-pointer"
        (click)="inputLogoEmpresa.click()"
      >
        <ng-container *ngIf="!imagemCarregada">
          <span>+ LOGO</span>
        </ng-container>
        <ng-container *ngIf="imagemCarregada">
          <img [src]="imageFile?.link" [alt]="imageFile?.name" />
        </ng-container>
        <input type="file" #inputLogoEmpresa style="display: none" accept="image/png" (change)="onImageInput($event)" />
      </div>

      <div class="w-full wrapper">
        <div class="form-group">
          <input type="text" class="form-input" placeholder="Nome Fantasia" formControlName="name" />
        </div>
        <div class="form-group">
          <input type="text" class="form-input" placeholder="Razão Social" formControlName="trading" />
        </div>
        <div class="form-group">
          <ng-select
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            placeholder="Tipo de Empresa"
            formControlName="type"
          >
            <ng-option *ngFor="let opcaoTipoCompany of opcoesTipoCompany" [value]="opcaoTipoCompany">
              {{ opcaoTipoCompany }}
            </ng-option>
          </ng-select>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-input"
            placeholder="CNPJ"
            formControlName="document"
            mask="00.000.000/0000-00"
          />
        </div>
        <div class="form-group">
          <input type="email" class="form-input" placeholder="E-mail do Administrador" formControlName="email" />
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-input"
            placeholder="Contato"
            formControlName="phone"
            mask="(00) 0000-0000||(00) 0 0000-0000"
          />
        </div>
        <div class="form-group" *isAllowed="[ERoleAdminString.Admin]">
          <ng-select
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            placeholder="Parceiro"
            formControlName="partnerId"
          >
            <ng-option *ngFor="let partner of partners" [value]="partner.id">
              {{ partner.name }}
            </ng-option>
          </ng-select>
        </div>
        <div class="form-group">
          <button
            *isAllowed="[ERoleAdminString.Admin, 'company.create']"
            (click)="salvarCompany()"
            class="h-9 btn btn--secondary"
          >
            + Salvar Empresa
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-container>
